export default {
    controller: 'navigationController',
    template: require('../views/navigation.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/navigation.component.js